export const NAMESPACE = "Permissions";
